(function () {
  console.log('NS Pase JS version: article-flow-2026-05-15-01');

  var GOOGLE_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbxzdmt4iw0DLxetKyvtsxEnQUqRLL1z7IDa_aL_E-PjI2_vIfYnKyrOs0LY3J7_Gnrg/exec';
  var ROOT_SELECTOR = '[data-ns-pase-register-root]';
  var ARTICLE_COUNT_MIN = 1;
  var ARTICLE_COUNT_MAX = 20;
  var MAX_SUGGESTIONS = 8;
  var SUCCESS_REDIRECT_SECONDS = 10;
  var SUCCESS_REDIRECT_URL = 'https://nylinskeppstedt.com/';

  var BRAND_STATUSES = {
    approved: {
      className: 'ns-pase-register__brand-status ns-pase-register__brand-status--approved',
      message: 'Vi tar emot detta varumärke'
    },
    restricted: {
      className: 'ns-pase-register__brand-status ns-pase-register__brand-status--restricted',
      message: 'Detta varumärke tas emot selektivt'
    },
    rejected: {
      className: 'ns-pase-register__brand-status ns-pase-register__brand-status--rejected',
      message: 'Vi tar inte emot detta varumärke'
    },
    unknown: {
      className: 'ns-pase-register__brand-status ns-pase-register__brand-status--unknown',
      message: 'Varumärket finns inte i listan. Vi gör alltid en slutlig bedömning vid hantering.'
    }
  };

  function normalizeText(value) {
    return (value || '')
      .toString()
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  function clampCount(value) {
    var numeric = parseInt(value, 10);

    if (Number.isNaN(numeric)) {
      return ARTICLE_COUNT_MIN;
    }

    return Math.min(ARTICLE_COUNT_MAX, Math.max(ARTICLE_COUNT_MIN, numeric));
  }

  function parseSelectedCount(value) {
    if (value === '' || value === null || typeof value === 'undefined') {
      return null;
    }

    return clampCount(value);
  }

  function initAll() {
    var roots = document.querySelectorAll(ROOT_SELECTOR);

    roots.forEach(function (root) {
      if (root.dataset.initialized === 'true') {
        return;
      }

      root.dataset.initialized = 'true';
      initRoot(root);
    });
  }

  function initRoot(root) {
    var form = root.querySelector('[data-ns-pase-register-form]');
    var formShell = root.querySelector('[data-ns-pase-form-shell]') || form;
    var page = root.querySelector('[data-ns-pase-page]');
    var accessModal = root.querySelector('[data-ns-pase-access-modal]');
    var accessPanel = root.querySelector('[data-ns-pase-access-panel]');
    var accessLoading = root.querySelector('[data-ns-pase-access-loading]');
    var accessFallback = root.querySelector('[data-ns-pase-access-fallback]');
    var accessCaseInput = root.querySelector('[data-ns-pase-access-case]');
    var accessEmailInput = root.querySelector('[data-ns-pase-access-email]');
    var accessSubmit = root.querySelector('[data-ns-pase-access-submit]');
    var accessError = root.querySelector('[data-ns-pase-access-message]');
    var accessMessage = root.querySelector('[data-ns-pase-access-notice]');
    var success = root.querySelector('[data-ns-pase-register-success]');
    var articlesContainer = root.querySelector('[data-ns-pase-register-articles]');
    var articleTemplate = root.querySelector('[data-ns-pase-register-article-template]');
    var countInput = root.querySelector('[data-ns-pase-register-count]');
    var submitButton = root.querySelector('[data-ns-pase-register-submit]');
    var errorBox = root.querySelector('[data-ns-pase-register-error]');
    var submitNote = root.querySelector('[data-ns-pase-register-submit-note]');
    var countdownNode = root.querySelector('[data-ns-pase-register-countdown]');
    var confirmationSection = root.querySelector('[data-ns-pase-register-confirmation-section]');
    var termsSection = root.querySelector('[data-ns-pase-register-terms-section]');
    var sectionId = root.getAttribute('data-section-id') || 'main';
    var brandsUrl = root.getAttribute('data-brands-url');
    var itemTypesUrl = root.getAttribute('data-item-types-url');
    var endpoint = root.dataset.endpoint;

    if (!form || !articlesContainer || !articleTemplate || !countInput || !submitButton || !errorBox) {
      return;
    }

    setAccessModalOpen(true);

    if (success) {
      success.hidden = true;
    }

    var redirectTimerId = null;
    var redirectCountdown = SUCCESS_REDIRECT_SECONDS;
    var brandEntries = [];
    var brandLookup = Object.create(null);
    var itemTypeEntries = [];
    var completedArticles = [];
    var activeArticleIndex = 0;
    var accessState = {
      valid: false,
      token: '',
      caseNumber: '',
      email: ''
    };

    function hasValidEndpoint() {
      return Boolean(
        endpoint &&
        endpoint !== 'undefined' &&
        endpoint !== 'PASTE_GOOGLE_APPS_SCRIPT_WEB_APP_URL_HERE'
      );
    }

    function setError(message) {
      if (!message) {
        errorBox.hidden = true;
        errorBox.textContent = '';
        return;
      }

      errorBox.hidden = false;
      errorBox.textContent = message;
    }

    function setAccessError(message) {
      if (!accessError) {
        return;
      }

      if (!message) {
        accessError.hidden = true;
        accessError.textContent = '';
        return;
      }

      accessError.hidden = false;
      accessError.textContent = message;
    }

    function setAccessMessage(message) {
      if (!accessMessage) {
        return;
      }

      if (!message) {
        accessMessage.hidden = true;
        accessMessage.textContent = '';
        return;
      }

      accessMessage.hidden = false;
      accessMessage.textContent = message;
    }

    function setAccessLoading(isLoading) {
      if (accessLoading) {
        accessLoading.hidden = !isLoading;
      }

      if (accessSubmit) {
        accessSubmit.disabled = isLoading;
        accessSubmit.textContent = isLoading ? 'Kontrollerar...' : 'Öppna registrering';
      }
    }

    function setAccessModalOpen(isOpen) {
      root.classList.toggle('ns-pase-register--access-locked', isOpen);

      if (accessModal) {
        accessModal.hidden = !isOpen;
      }

      if (page) {
        if (isOpen) {
          page.setAttribute('aria-hidden', 'true');
        } else {
          page.removeAttribute('aria-hidden');
        }

        if ('inert' in page) {
          page.inert = isOpen;
        }
      }
    }

    function lockAccessPrefilledField(field, title) {
      if (!field) {
        return;
      }

      field.readOnly = true;
      field.classList.add('ns-pase-register__input--locked');
      field.setAttribute('aria-readonly', 'true');
      field.title = title;
    }

    function showAccessFallback(message) {
      if (accessPanel) {
        accessPanel.hidden = false;
      }

      if (accessFallback) {
        accessFallback.hidden = false;
      }

      setAccessModalOpen(true);
      setAccessLoading(false);
      setAccessMessage('');
      setAccessError(message || '');

      if (accessCaseInput && !accessCaseInput.value) {
        accessCaseInput.focus();
      }
    }

    function showAccessLockedMessage(message) {
      if (accessPanel) {
        accessPanel.hidden = false;
      }

      if (accessFallback) {
        accessFallback.hidden = true;
      }

      setAccessModalOpen(true);
      setAccessLoading(false);
      setAccessError('');
      setAccessMessage(message || 'Den här registreringen kan inte öppnas.');
    }

    function getUrlToken() {
      try {
        return new URLSearchParams(window.location.search).get('token') || '';
      } catch (error) {
        return '';
      }
    }

    function buildAccessValidationUrl(parameters) {
      var url = new URL(endpoint || GOOGLE_SCRIPT_URL, window.location.href);

      url.searchParams.set('action', 'validate_ns_pase_access');

      Object.keys(parameters).forEach(function (key) {
        if (parameters[key]) {
          url.searchParams.set(key, parameters[key]);
        }
      });

      return url.toString();
    }

    function validateAccess(parameters) {
      if (!hasValidEndpoint()) {
        return Promise.reject(new Error('Missing endpoint'));
      }

      return fetch(buildAccessValidationUrl(parameters), {
        method: 'GET',
        cache: 'no-store'
      }).then(function (response) {
        if (!response.ok) {
          throw new Error('Access validation failed');
        }

        return response.json();
      });
    }

    function unlockRegistration(result, context) {
      var details = context || {};

      accessState.valid = true;
      accessState.token = details.token || '';
      accessState.caseNumber = result.case_number || details.caseNumber || '';
      accessState.email = result.email || details.email || '';

      if (form.elements.name && result.name) {
        form.elements.name.value = result.name;
        lockAccessPrefilledField(form.elements.name, 'Namn hämtas från din NS Påse-beställning.');
      }

      if (form.elements.email && accessState.email) {
        form.elements.email.value = accessState.email;
        lockAccessPrefilledField(form.elements.email, 'E-postadressen är kopplad till din verifierade NS Påse.');
      }

      if (accessPanel) {
        accessPanel.hidden = true;
      }

      setAccessModalOpen(false);
      formShell.hidden = false;
      setAccessLoading(false);
      setAccessError('');
      setAccessMessage('');
      setError('');
    }

    function handleAccessResult(result, context) {
      if (result && result.valid) {
        unlockRegistration(result, context);
        return;
      }

      if (result && result.reason === 'already_registered') {
        showAccessLockedMessage(result.message || 'Den här NS Påsen är redan registrerad.');
        return;
      }

      showAccessFallback('Vi kunde inte verifiera din NS Påse. Kontrollera ärendenummer och e-postadress.');
    }

    function validateTokenFromUrl() {
      var token = getUrlToken();

      if (!token) {
        showAccessFallback('');
        return;
      }

      if (accessPanel) {
        accessPanel.hidden = false;
      }

      if (accessFallback) {
        accessFallback.hidden = true;
      }

      setAccessModalOpen(true);
      setAccessError('');
      setAccessMessage('');
      setAccessLoading(true);

      validateAccess({ token: token })
        .then(function (result) {
          handleAccessResult(result, { token: token });
        })
        .catch(function () {
          showAccessFallback('Vi kunde inte verifiera länken just nu. Formuläret är låst tills NS Påse-verifieringen fungerar. Du kan prova med ärendenummer och e-postadress nedan.');
        });
    }

    function submitFallbackAccess() {
      var caseNumber = accessCaseInput ? accessCaseInput.value.trim() : '';
      var email = accessEmailInput ? accessEmailInput.value.trim() : '';

      if (!caseNumber || !email) {
        showAccessFallback('Ange både ärendenummer och e-postadress.');
        return;
      }

      setAccessError('');
      setAccessMessage('');
      setAccessLoading(true);

      validateAccess({
        case_number: caseNumber,
        email: email
      }).then(function (result) {
        handleAccessResult(result, {
          caseNumber: caseNumber,
          email: email
        });
      }).catch(function () {
        showAccessFallback('Det gick inte att verifiera uppgifterna just nu. Formuläret är låst tills NS Påse-verifieringen fungerar. Försök igen om en liten stund.');
      });
    }

    function clearRedirectTimer() {
      if (redirectTimerId) {
        window.clearInterval(redirectTimerId);
        redirectTimerId = null;
      }
    }

    function updateCountdownText(secondsRemaining) {
      if (countdownNode) {
        countdownNode.textContent = 'Du skickas tillbaka till startsidan om ' + secondsRemaining + ' sekunder.';
      }
    }

    function startRedirectCountdown() {
      clearRedirectTimer();
      redirectCountdown = SUCCESS_REDIRECT_SECONDS;
      updateCountdownText(redirectCountdown);

      redirectTimerId = window.setInterval(function () {
        redirectCountdown -= 1;

        if (redirectCountdown <= 0) {
          clearRedirectTimer();
          window.location.href = SUCCESS_REDIRECT_URL;
          return;
        }

        updateCountdownText(redirectCountdown);
      }, 1000);
    }

    function getArticleFields(articleNode) {
      return {
        brand: articleNode.querySelector('[data-ns-pase-register-brand]'),
        type: articleNode.querySelector('[data-ns-pase-register-type]'),
        color: articleNode.querySelector('[data-ns-pase-register-color]'),
        size: articleNode.querySelector('[data-ns-pase-register-size]'),
        comment: articleNode.querySelector('[data-ns-pase-register-comment]'),
        nextButton: articleNode.querySelector('[data-ns-pase-register-article-next]')
      };
    }

    function getExistingArticles() {
      return Array.prototype.map.call(
        articlesContainer.querySelectorAll('[data-ns-pase-register-article]'),
        function (articleNode) {
          var fields = getArticleFields(articleNode);

          return {
            brand: fields.brand ? fields.brand.value : '',
            type: fields.type ? fields.type.value : '',
            color: fields.color ? fields.color.value : '',
            size: fields.size ? fields.size.value : '',
            comment: fields.comment ? fields.comment.value : '',
            isComplete: articleNode.dataset.articleComplete === 'true'
          };
        }
      );
    }

    function getFirstIncompleteIndex() {
      var index = completedArticles.findIndex(function (isComplete) {
        return !isComplete;
      });

      return index === -1 ? null : index;
    }

    function getBrandStatusByName(value) {
      var normalized = normalizeText(value);

      if (!normalized || !brandLookup[normalized]) {
        return 'unknown';
      }

      return brandLookup[normalized].status;
    }

    function isRejectedBrandStatus(statusKey) {
      return statusKey === 'rejected';
    }

    function setBrandStatus(statusNode, statusKey) {
      var config = BRAND_STATUSES[statusKey] || BRAND_STATUSES.unknown;
      statusNode.className = config.className;
      statusNode.textContent = config.message;
      statusNode.dataset.brandStatus = statusKey in BRAND_STATUSES ? statusKey : 'unknown';
      statusNode.hidden = false;
    }

    function hideBrandStatus(statusNode) {
      statusNode.hidden = true;
      statusNode.dataset.brandStatus = '';
    }

    function setArticleFieldsEnabled(articleNode, enabled) {
      var fields = getArticleFields(articleNode);

      ['brand', 'type', 'color', 'size', 'comment'].forEach(function (key) {
        if (!fields[key]) {
          return;
        }

        fields[key].disabled = !enabled;

        if (key === 'comment') {
          fields[key].required = false;
        } else {
          fields[key].required = enabled;
        }
      });

      if (fields.nextButton) {
        fields.nextButton.disabled = !enabled;
      }
    }

    function isArticleReady(articleNode) {
      var fields = getArticleFields(articleNode);
      var brandValue = fields.brand ? fields.brand.value : '';
      var statusKey = getBrandStatusByName(brandValue);
      var requiredKeys = ['brand', 'type', 'color', 'size'];

      if (isRejectedBrandStatus(statusKey)) {
        return false;
      }

      return requiredKeys.every(function (key) {
        return fields[key] && fields[key].checkValidity();
      });
    }

    function updateArticleActionState(articleNode) {
      var fields = getArticleFields(articleNode);

      if (!fields.nextButton) {
        return;
      }

      fields.nextButton.hidden = !isArticleReady(articleNode);
      fields.nextButton.disabled = !isArticleReady(articleNode);
    }

    function syncArticleState(articleNode, brandValue) {
      var statusNode = articleNode.querySelector('[data-ns-pase-register-brand-status]');
      var fields = getArticleFields(articleNode);
      var normalizedBrand = normalizeText(brandValue);
      var statusKey = getBrandStatusByName(brandValue);

      if (!statusNode) {
        return;
      }

      if (!normalizedBrand) {
        hideBrandStatus(statusNode);

        ['type', 'color', 'size'].forEach(function (key) {
          if (fields[key]) {
            fields[key].disabled = false;
            fields[key].required = true;
          }
        });

        if (fields.comment) {
          fields.comment.disabled = false;
          fields.comment.required = false;
        }

        updateArticleActionState(articleNode);

        return;
      }

      setBrandStatus(statusNode, statusKey);

      if (isRejectedBrandStatus(statusKey)) {
        ['type', 'color', 'size', 'comment'].forEach(function (key) {
          if (fields[key]) {
            fields[key].disabled = true;
            fields[key].required = false;
          }
        });
      } else {
        ['type', 'color', 'size'].forEach(function (key) {
          if (fields[key]) {
            fields[key].disabled = false;
            fields[key].required = true;
          }
        });

        if (fields.comment) {
          fields.comment.disabled = false;
          fields.comment.required = false;
        }
      }

      updateArticleActionState(articleNode);
    }

    function buildSuggestionButton(match) {
      var suggestion = typeof match === 'string' ? { value: match, label: match } : match;
      var button = document.createElement('button');
      var label = document.createElement('span');
      var meta;

      button.type = 'button';
      button.className = 'ns-pase-register__suggestion';
      button.setAttribute('role', 'option');
      button.dataset.suggestionValue = suggestion.value || suggestion.label || '';

      label.className = 'ns-pase-register__suggestion-label';
      label.textContent = suggestion.label || suggestion.value || '';
      button.appendChild(label);

      if (suggestion.meta) {
        meta = document.createElement('span');
        meta.className = 'ns-pase-register__suggestion-meta';
        meta.textContent = suggestion.meta;
        button.appendChild(meta);
      }

      return button;
    }

    function initAutocomplete(config) {
      var input = config.input;
      var list = config.list;
      var getMatches = config.getMatches;
      var onChange = config.onChange || function () {};
      var activeIndex = -1;

      if (!input || !list) {
        return;
      }

      function closeSuggestions() {
        activeIndex = -1;
        list.innerHTML = '';
        list.hidden = true;
        input.setAttribute('aria-expanded', 'false');
      }

      function updateActiveSuggestion() {
        var suggestionButtons = list.querySelectorAll('.ns-pase-register__suggestion');

        suggestionButtons.forEach(function (button, index) {
          button.classList.toggle('is-active', index === activeIndex);
        });
      }

      function applyValue(value) {
        input.value = value;
        onChange(value);
        closeSuggestions();
      }

      function showSuggestions(matches) {
        list.innerHTML = '';

        if (!matches.length) {
          closeSuggestions();
          return;
        }

        matches.forEach(function (match) {
          var item = document.createElement('li');
          item.className = 'ns-pase-register__suggestion-item';
          item.appendChild(buildSuggestionButton(match));
          list.appendChild(item);
        });

        activeIndex = -1;
        list.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      }

      input.addEventListener('input', function () {
        var value = input.value;
        showSuggestions(getMatches(value));
        onChange(value);
      });

      input.addEventListener('focus', function () {
        var matches = getMatches(input.value);

        if (matches.length) {
          showSuggestions(matches);
        }
      });

      input.addEventListener('blur', function () {
        window.setTimeout(function () {
          closeSuggestions();
          onChange(input.value);
        }, 120);
      });

      input.addEventListener('keydown', function (event) {
        var suggestionButtons = list.querySelectorAll('.ns-pase-register__suggestion');

        if (list.hidden || !suggestionButtons.length) {
          return;
        }

        if (event.key === 'ArrowDown') {
          event.preventDefault();
          activeIndex = (activeIndex + 1) % suggestionButtons.length;
          updateActiveSuggestion();
          return;
        }

        if (event.key === 'ArrowUp') {
          event.preventDefault();
          activeIndex = activeIndex <= 0 ? suggestionButtons.length - 1 : activeIndex - 1;
          updateActiveSuggestion();
          return;
        }

        if (event.key === 'Enter' && activeIndex >= 0) {
          event.preventDefault();
          applyValue(suggestionButtons[activeIndex].dataset.suggestionValue || '');
          return;
        }

        if (event.key === 'Escape') {
          closeSuggestions();
        }
      });

      list.addEventListener('click', function (event) {
        var button = event.target.closest('.ns-pase-register__suggestion');

        if (!button) {
          return;
        }

        applyValue(button.dataset.suggestionValue || '');
      });

      onChange(input.value);
    }

    function getBrandMatches(value) {
      var normalizedValue = normalizeText(value);

      if (!normalizedValue) {
        return [];
      }

      return brandEntries
        .filter(function (entry) {
          return entry.normalized.indexOf(normalizedValue) !== -1;
        })
        .slice(0, MAX_SUGGESTIONS)
        .map(function (entry) {
          return {
            value: entry.name,
            label: entry.name
          };
        });
    }

    function getTypeMatches(value) {
      var normalizedValue = normalizeText(value);

      if (!normalizedValue) {
        return [];
      }

      return itemTypeEntries
        .filter(function (entry) {
          return entry.normalized.indexOf(normalizedValue) !== -1;
        })
        .slice(0, MAX_SUGGESTIONS)
        .map(function (entry) {
          return {
            value: entry.name,
            label: entry.name,
            meta: entry.category || ''
          };
        });
    }

    function buildArticleSummary(articleNode, index) {
      var fields = getArticleFields(articleNode);
      var summaryText = articleNode.querySelector('[data-ns-pase-register-article-summary-text]');
      var brand = fields.brand ? fields.brand.value.trim() : '';
      var type = fields.type ? fields.type.value.trim() : '';
      var color = fields.color ? fields.color.value.trim() : '';
      var size = fields.size ? fields.size.value.trim() : '';
      var parts = [
        brand || 'Ej angivet',
        type || 'Ej angivet',
        color || 'Ej angivet',
        size || 'Ej angivet'
      ];

      if (summaryText) {
        summaryText.textContent = 'Artikel ' + (index + 1) + ' – ' + parts.join(', ');
      }
    }

    function isReadyForSubmit() {
      return completedArticles.length > 0 &&
        completedArticles.every(Boolean) &&
        activeArticleIndex === null;
    }

    function updateFinalStageVisibility() {
      var ready = isReadyForSubmit();

      if (confirmationSection) {
        confirmationSection.hidden = !ready;
      }

      submitButton.hidden = !ready;
      submitNote.hidden = !ready || submitButton.disabled;
    }

    function updateFlowState() {
      var articleNodes = articlesContainer.querySelectorAll('[data-ns-pase-register-article]');

      Array.prototype.forEach.call(articleNodes, function (articleNode, index) {
        var summaryButton = articleNode.querySelector('[data-ns-pase-register-article-summary]');
        var editor = articleNode.querySelector('[data-ns-pase-register-article-editor]');
        var fields = getArticleFields(articleNode);
        var isActive = activeArticleIndex === index;
        var isComplete = completedArticles[index] === true;

        articleNode.dataset.articleComplete = isComplete ? 'true' : 'false';
        buildArticleSummary(articleNode, index);

        if (isActive) {
          articleNode.hidden = false;

          if (summaryButton) {
            summaryButton.hidden = true;
          }

          if (editor) {
            editor.hidden = false;
          }

          setArticleFieldsEnabled(articleNode, true);
          syncArticleState(articleNode, fields.brand ? fields.brand.value : '');

          if (fields.nextButton) {
            fields.nextButton.textContent = 'Lägg till';
          }

          updateArticleActionState(articleNode);

          return;
        }

        if (isComplete) {
          articleNode.hidden = false;

          if (summaryButton) {
            summaryButton.hidden = false;
          }

          if (editor) {
            editor.hidden = true;
          }

          setArticleFieldsEnabled(articleNode, false);

          if (fields.nextButton) {
            fields.nextButton.hidden = true;
          }

          return;
        }

        articleNode.hidden = true;

        if (summaryButton) {
          summaryButton.hidden = true;
        }

        if (editor) {
          editor.hidden = true;
        }

        setArticleFieldsEnabled(articleNode, false);

        if (fields.nextButton) {
          fields.nextButton.hidden = true;
        }
      });

      updateFinalStageVisibility();
    }

    function initArticleNode(articleNode, index) {
      var fields = getArticleFields(articleNode);
      var brandSuggestions = articleNode.querySelector('[data-ns-pase-register-suggestions]');
      var typeSuggestions = articleNode.querySelector('[data-ns-pase-register-type-suggestions]');
      var summaryButton = articleNode.querySelector('[data-ns-pase-register-article-summary]');
      var nextButton = articleNode.querySelector('[data-ns-pase-register-article-next]');
      var brandStatus = articleNode.querySelector('[data-ns-pase-register-brand-status]');
      var brandLabel = articleNode.querySelector('[data-ns-pase-register-brand-label]');
      var typeLabel = articleNode.querySelector('[data-ns-pase-register-type-label]');
      var colorLabel = articleNode.querySelector('[data-ns-pase-register-color-label]');
      var sizeLabel = articleNode.querySelector('[data-ns-pase-register-size-label]');
      var commentLabel = articleNode.querySelector('[data-ns-pase-register-comment-label]');

      if (fields.brand) {
        fields.brand.id = 'ns-pase-register-brand-' + sectionId + '-' + (index + 1);
        fields.brand.name = 'article_brand_' + (index + 1);
        fields.brand.setAttribute('aria-controls', 'ns-pase-register-brand-suggestions-' + sectionId + '-' + (index + 1));
      }

      if (brandLabel && fields.brand) {
        brandLabel.htmlFor = fields.brand.id;
      }

      if (brandSuggestions) {
        brandSuggestions.id = 'ns-pase-register-brand-suggestions-' + sectionId + '-' + (index + 1);
      }

      if (fields.type) {
        fields.type.id = 'ns-pase-register-type-' + sectionId + '-' + (index + 1);
        fields.type.name = 'article_type_' + (index + 1);
        fields.type.setAttribute('aria-controls', 'ns-pase-register-type-suggestions-' + sectionId + '-' + (index + 1));
      }

      if (typeLabel && fields.type) {
        typeLabel.htmlFor = fields.type.id;
      }

      if (typeSuggestions) {
        typeSuggestions.id = 'ns-pase-register-type-suggestions-' + sectionId + '-' + (index + 1);
      }

      if (fields.color) {
        fields.color.id = 'ns-pase-register-color-' + sectionId + '-' + (index + 1);
        fields.color.name = 'article_color_' + (index + 1);
      }

      if (colorLabel && fields.color) {
        colorLabel.htmlFor = fields.color.id;
      }

      if (fields.size) {
        fields.size.id = 'ns-pase-register-size-' + sectionId + '-' + (index + 1);
        fields.size.name = 'article_size_' + (index + 1);
      }

      if (sizeLabel && fields.size) {
        sizeLabel.htmlFor = fields.size.id;
      }

      if (fields.comment) {
        fields.comment.id = 'ns-pase-register-comment-' + sectionId + '-' + (index + 1);
        fields.comment.name = 'article_comment_' + (index + 1);
      }

      if (commentLabel && fields.comment) {
        commentLabel.htmlFor = fields.comment.id;
      }

      initAutocomplete({
        input: fields.brand,
        list: brandSuggestions,
        getMatches: getBrandMatches,
        onChange: function (value) {
          syncArticleState(articleNode, value);
        }
      });

      initAutocomplete({
        input: fields.type,
        list: typeSuggestions,
        getMatches: getTypeMatches,
        onChange: function () {
          updateArticleActionState(articleNode);
        }
      });

      if (brandStatus) {
        hideBrandStatus(brandStatus);
      }

      ['color', 'size', 'comment'].forEach(function (key) {
        if (fields[key]) {
          fields[key].addEventListener('input', function () {
            updateArticleActionState(articleNode);
          });
          fields[key].addEventListener('change', function () {
            updateArticleActionState(articleNode);
          });
        }
      });

      if (summaryButton) {
        summaryButton.addEventListener('click', function () {
          setError('');
          activeArticleIndex = index;
          updateFlowState();

          if (fields.brand) {
            fields.brand.focus();
          }
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', function () {
          if (!validateArticle(index)) {
            return;
          }

          completedArticles[index] = true;
          activeArticleIndex = getFirstIncompleteIndex();
          updateFlowState();

          if (activeArticleIndex === null && termsSection) {
            window.setTimeout(function () {
              termsSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }, 60);
          }
        });
      }

      updateArticleActionState(articleNode);
    }

    function renderArticles(count) {
      var total = parseSelectedCount(count);
      var existing = getExistingArticles();

      articlesContainer.innerHTML = '';
      completedArticles = [];

      if (total === null) {
        activeArticleIndex = null;
        updateFinalStageVisibility();
        return;
      }

      countInput.value = String(total);

      for (var index = 0; index < total; index += 1) {
        var articleData = existing[index] || {};
        var fragment = articleTemplate.content.cloneNode(true);
        var articleNode = fragment.querySelector('[data-ns-pase-register-article]');
        var titleNode = fragment.querySelector('.ns-pase-register__article-title');
        var fields;

        if (titleNode) {
          titleNode.textContent = 'Artikel ' + (index + 1);
        }

        articlesContainer.appendChild(fragment);
        articleNode = articlesContainer.querySelectorAll('[data-ns-pase-register-article]')[index];
        fields = getArticleFields(articleNode);

        if (fields.brand) {
          fields.brand.value = articleData.brand || '';
        }

        if (fields.type) {
          fields.type.value = articleData.type || '';
        }

        if (fields.color) {
          fields.color.value = articleData.color || '';
        }

        if (fields.size) {
          fields.size.value = articleData.size || '';
        }

        if (fields.comment) {
          fields.comment.value = articleData.comment || '';
        }

        completedArticles[index] = articleData.isComplete === true;
        initArticleNode(articleNode, index);
      }

      activeArticleIndex = getFirstIncompleteIndex();
      updateFlowState();
    }

    function validateArticle(index) {
      var articleNode = articlesContainer.querySelectorAll('[data-ns-pase-register-article]')[index];
      var fields = getArticleFields(articleNode);
      var statusNode = articleNode.querySelector('[data-ns-pase-register-brand-status]');
      var invalidField = null;
      var hasRejectedBrand;

      if (!articleNode) {
        return false;
      }

      setError('');
      syncArticleState(articleNode, fields.brand ? fields.brand.value : '');

      hasRejectedBrand = statusNode && isRejectedBrandStatus(statusNode.dataset.brandStatus);

      if (hasRejectedBrand) {
        setError('Vi tar inte emot detta varumärke. Välj ett annat varumärke innan du lägger till artikeln.');
        return false;
      }

      ['brand', 'type', 'color', 'size'].some(function (key) {
        if (fields[key] && !fields[key].checkValidity()) {
          invalidField = fields[key];
          return true;
        }

        return false;
      });

      if (invalidField) {
        setError('Fyll i varumärke, typ av vara, färg och storlek innan du lägger till artikeln.');
        invalidField.reportValidity();
        invalidField.focus();
        return false;
      }

      return true;
    }

    function collectPayload() {
      var articleNodes = articlesContainer.querySelectorAll('[data-ns-pase-register-article]');
      var articles = Array.prototype.map.call(articleNodes, function (articleNode, index) {
        var fields = getArticleFields(articleNode);
        var brandValue = fields.brand ? fields.brand.value.trim() : '';

        return {
          index: index + 1,
          brand: brandValue,
          brand_status: getBrandStatusByName(brandValue),
          type: fields.type ? fields.type.value.trim() : '',
          color: fields.color ? fields.color.value.trim() : '',
          size: fields.size ? fields.size.value.trim() : '',
          comment: fields.comment ? fields.comment.value.trim() : ''
        };
      });

      return {
        ns_pase_token: accessState.token,
        ns_pase_case_number: accessState.caseNumber,
        submitted_at: new Date().toISOString(),
        name: form.elements.name.value.trim(),
        customer_id: form.elements.customer_id.value.trim(),
        email: form.elements.email.value.trim(),
        phone: form.elements.phone.value.trim(),
        article_count: clampCount(form.elements.article_count.value),
        articles: articles,
        accepted_item_confirmation: form.elements.accepted_item_confirmation.checked,
        accepted_terms: form.elements.accepted_terms.checked
      };
    }

    function validateBeforeSubmit() {
      var hasRejectedBrand;

      setError('');

      if (!hasValidEndpoint()) {
        setError('Formuläret kunde inte skickas eftersom formulärets endpoint saknas eller är felaktig.');
        return false;
      }

      if (!accessState.valid || !accessState.caseNumber) {
        setError('Din NS Påse behöver verifieras innan du kan skicka registreringen.');
        return false;
      }

      if (!isReadyForSubmit()) {
        setError('Lägg till alla artiklar innan du slutför registreringen.');
        return false;
      }

      hasRejectedBrand = Array.prototype.some.call(
        articlesContainer.querySelectorAll('[data-ns-pase-register-article]'),
        function (articleNode) {
          var fields = getArticleFields(articleNode);
          return isRejectedBrandStatus(getBrandStatusByName(fields.brand ? fields.brand.value : ''));
        }
      );

      if (hasRejectedBrand) {
        setError('En eller flera artiklar innehåller varumärken som vi inte tar emot. Ändra artikeln innan du slutför registreringen.');
        return false;
      }

      if (!form.checkValidity()) {
        Array.from(form.elements).forEach(function (field) {
          if (field.willValidate && !field.checkValidity()) {
            field.reportValidity();
          }
        });
        return false;
      }

      return true;
    }

    function setSubmitting(isSubmitting) {
      submitButton.disabled = isSubmitting;
      submitButton.textContent = isSubmitting ? 'Skickar registrering...' : 'Slutför registrering';
      submitNote.hidden = isSubmitting || !isReadyForSubmit();
    }

    function showSuccess() {
      setAccessModalOpen(false);
      formShell.hidden = true;
      success.hidden = false;
      setError('');
      startRedirectCountdown();
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function loadBrands() {
      if (!brandsUrl) {
        return Promise.resolve();
      }

      return fetch(brandsUrl, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Could not load brands');
          }

          return response.json();
        })
        .then(function (data) {
          brandEntries = [];
          brandLookup = Object.create(null);

          ['approved', 'restricted', 'rejected'].forEach(function (status) {
            var list = Array.isArray(data[status]) ? data[status] : [];

            list.forEach(function (name) {
              var normalized = normalizeText(name);

              if (!normalized || brandLookup[normalized]) {
                return;
              }

              var entry = {
                name: name,
                normalized: normalized,
                status: status
              };

              brandEntries.push(entry);
              brandLookup[normalized] = entry;
            });
          });

          brandEntries.sort(function (first, second) {
            return first.name.localeCompare(second.name, 'sv');
          });
        })
        .catch(function () {
          setError('Varumärkeslistan kunde inte laddas just nu. Du kan fortfarande fylla i formuläret manuellt.');
        });
    }

    function loadItemTypes() {
      if (!itemTypesUrl) {
        return Promise.resolve();
      }

      return fetch(itemTypesUrl, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Could not load item types');
          }

          return response.json();
        })
        .then(function (data) {
          var normalizedLookup = Object.create(null);
          var flattenedEntries = [];

          if (Array.isArray(data.types)) {
            data.types.forEach(function (name) {
              var normalized = normalizeText(name);

              if (!normalized || normalizedLookup[normalized]) {
                return;
              }

              normalizedLookup[normalized] = true;
              flattenedEntries.push({
                name: name,
                normalized: normalized,
                category: ''
              });
            });
          }

          if (data.categories && typeof data.categories === 'object') {
            Object.keys(data.categories).forEach(function (categoryName) {
              var names = Array.isArray(data.categories[categoryName]) ? data.categories[categoryName] : [];

              names.forEach(function (name) {
                var normalized = normalizeText(name);

                if (!normalized || normalizedLookup[normalized]) {
                  return;
                }

                normalizedLookup[normalized] = true;
                flattenedEntries.push({
                  name: name,
                  normalized: normalized,
                  category: categoryName
                });
              });
            });
          }

          itemTypeEntries = flattenedEntries;
        })
        .catch(function () {
          itemTypeEntries = [];
        });
    }

    if (accessSubmit) {
      accessSubmit.addEventListener('click', submitFallbackAccess);
    }

    [accessCaseInput, accessEmailInput].forEach(function (input) {
      if (!input) {
        return;
      }

      input.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          submitFallbackAccess();
        }
      });
    });

    countInput.addEventListener('change', function () {
      renderArticles(countInput.value);
    });

    countInput.addEventListener('input', function () {
      var numeric = parseSelectedCount(countInput.value);

      if (numeric !== null) {
        renderArticles(numeric);
        return;
      }

      renderArticles(null);
    });

    form.addEventListener('submit', async function (event) {
      var payload;
      var body;
      var response;
      var responseText;
      var result;

      event.preventDefault();

      if (!validateBeforeSubmit()) {
        return;
      }

      try {
        payload = collectPayload();
        body = JSON.stringify(payload);
      } catch (error) {
        setError('Det gick inte att förbereda formuläret för skickning. Försök igen.');
        return;
      }

      setSubmitting(true);

      try {
        response = await fetch(endpoint || GOOGLE_SCRIPT_URL, {
          method: 'POST',
          headers: {
            'Content-Type': 'text/plain;charset=utf-8'
          },
          body: body
        });

        responseText = await response.text();

        try {
          result = responseText ? JSON.parse(responseText) : null;
        } catch (parseError) {
          result = null;
        }

        if (!response.ok || !result || result.status !== 'ok') {
          throw new Error(result && result.message ? result.message : 'Submission failed');
        }

        showSuccess();
      } catch (error) {
        setError(error && error.message && error.message !== 'Submission failed'
          ? error.message
          : 'Det gick inte att skicka registreringen just nu. Försök igen om en liten stund.');
      } finally {
        setSubmitting(false);
      }
    });

    validateTokenFromUrl();
    renderArticles(parseSelectedCount(countInput.value));

    Promise.all([loadBrands(), loadItemTypes()]).finally(function () {
      renderArticles(parseSelectedCount(countInput.value));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
